import styled from "styled-components";

export const Container = styled.div`
	background: ${({ theme }) => theme.grayLight};
	border-radius: 4px;
	padding: 0.4rem;
	cursor: pointer;
`;

export const HeaderSupplier = styled.div`
	display: grid;
	grid-template-columns: 1fr 40px;
	gap: 0.4rem;
	align-items: center;
	min-width: 0;
`;

export const TitleSupplier = styled.h5`
	font-weight: bold;
	font-size: 1rem;
	margin: 0;
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
export const BodySupplier = styled.div``;
